import React from "react";
import { Field } from "formik";
import { Checkbox } from "components/Form/SpecialButtons";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import AdminDisabledField from "features/Admin/components/AdminDisabledField";

const OthersForm = ({ element, values }) => (
	<div>
		<AdminDisabledField title="Hors nomenclature" value={values.bionext_price} />
		<Field customlabel="Disponible dans la sélection rapide" component={Checkbox} name="isAvailableWithoutCatalog" id="isAvailableWithoutCatalog" />
		<Field customlabel="Analyse COVID" component={Checkbox} name="is_covid" id="is_covid" />
		<Field
			type="number"
			name="waiting_time_before_sampling"
			customlabel="Temps d'attente avant prélèvement (en min)"
			component={CustomInputTextComponent}
		/>
		<Field customlabel="Contrôle d'identité" component={Checkbox} name="identity_check" id="identity_check" />
		<Field customlabel="Calcul du coût" component={Checkbox} name="calculating_cost" id="calculating_cost" />
	</div>
);

export default OthersForm;
